import React from 'react';
import { useSelector } from 'react-redux';
import Close from 'src/assets/images/CloseProduct.svg';
import {
    OrderDetailTitleContainer,
    CloseIconContainer,
    CloseIcon,
    OrderDetailTitle,
    TitleSubContainer,
    TitleDateContainer,
    SurgeryDateContainer,
    Title
} from './OrderDetailHeader.styled';

import {
    OrderSurgeryFont,
    SurgeryCenterContainer,
} from 'src/pages/orders/components/orderDetails/OrderDetails.styled';

import { getDisplayDate } from 'src/utils/dateUtils';
import { fromOrderTypeToLabel } from 'src/utils/util';

import { useTranslation } from 'react-i18next';
import { sizes } from 'src/styles/Media.styled';
import moment from 'moment';
import {PARKED_LABEL} from 'src/styles/fonts/MCFontConstants';

const OrderDetailHeader = ({ orderListDetailsClose, isCondensedView }) => {
    const { t } = useTranslation();
    const isLanguageChanged = useSelector(
        (state) => state.loginReducer.isLanguageChanged
    );
    const { myCaseRef, orderBasicDetails,torqueRecorded } = useSelector(
        (state) => state.orderSummaryReducer
    );
    const {
        accountName,
        accountNumber,
        currentOrderType,
        isSaved,
        submitDate,
        surgeryDate,
        isMastOrder,
        orderSummaryDetail,
    } = orderBasicDetails || {};

    const { implantDate } = orderSummaryDetail || {};

    const handleOrderType = () => {
        if (currentOrderType) {
            return fromOrderTypeToLabel(currentOrderType, isMastOrder);
        } else {
            return null;
        }
    };
    const handleSurgeryDate = () => {
        if (surgeryDate) {
           
            return getDisplayDate(
                // new Date(
                //     surgeryDate.includes('2050')
                //         ? surgeryDate.replace('Z', '')
                //         : surgeryDate
                // )
                new Date(surgeryDate)
            );
        } else if (implantDate) {
            return getDisplayDate(implantDate);
        } else {
            return null;
        }
    };
    const handleAccountName = () => {
        if (accountName) {
            return accountName;
        } else {
            return null;
        }
    };

    const handleAccountNumber = () => {
        if (accountNumber) {
            return parseInt(accountNumber);
        } else {
            return null;
        }
    };

    const handleSubmitDate = () => {
        if (submitDate) {
            return getDisplayDate(new Date(submitDate));
        } else {
            return null;
        }
    };
    return (
        <>
            <OrderDetailTitleContainer
                padding={isCondensedView && '0 1rem 0 1rem'}
            >
                <OrderDetailTitle>{myCaseRef}</OrderDetailTitle>
                <TitleSubContainer>
                    <OrderSurgeryFont
                        isSurgeyType
                        isRegular
                        isConsignment={
                            orderBasicDetails?.currentOrderType === 'KE' ||
                            orderBasicDetails?.currentOrderType === 'ZKA' ||
                            orderBasicDetails?.currentOrderType === 'KB'
                        }
                        wordBreak={isLanguageChanged && 'keep-all'}
                        // isConsignmentAdd={orderBasicDetails.currentOrderType === 'KB'}
                    >
                        {handleOrderType()}
                    </OrderSurgeryFont>
                    <TitleDateContainer isMargin={'0.2rem'}>
                        <SurgeryDateContainer>
                            <OrderSurgeryFont
                                isRegular
                                marginRight={false}
                                wordBreak={isLanguageChanged && 'keep-all'}
                            >
                                {isSaved //Draft not submitted
                                    ? t('orders.orderSummaryTabs.saved')
                                    : t(
                                          'orders.priceOverrideHistoryStatus.submitted'
                                      )}
                            </OrderSurgeryFont>
                            {
                                <OrderSurgeryFont
                                    marginRight={false}
                                    isDemi
                                    isSurgeyDate
                                    isMargin={'0 2px'}
                                    mobileMargin={'2px'}
                                >
                                    {handleSubmitDate()}
                                </OrderSurgeryFont>
                            }
                        </SurgeryDateContainer>
                         <SurgeryDateContainer>
                        {torqueRecorded && <Title
                                   color = {PARKED_LABEL}
                                >
                                    {t('orders.recordTorque.torqueRecorded')}
                        </Title>}
                        </SurgeryDateContainer>
                        {(surgeryDate || implantDate) && (
                            <SurgeryDateContainer>
                                {orderBasicDetails?.currentOrderType === 'KE' ||
                                orderBasicDetails?.currentOrderType === 'ZOR' ||
                                orderBasicDetails?.currentOrderType === 'ZKA' ? (
                                    ''
                                ) : (
                                    <OrderSurgeryFont
                                        isRegular
                                        marginRight={false}
                                        wordBreak={
                                            isLanguageChanged && 'keep-all'
                                        }
                                    >
                                        {t(
                                            'orders.priceOverrideHistoryStatus.surgerydate'
                                        )}
                                    </OrderSurgeryFont>
                                )}
                                <OrderSurgeryFont
                                    marginRight={false}
                                    isDemi
                                    isSurgeyDate
                                    isMargin={'0 4px'}
                                    mobileMargin={'2px'}
                                >
                                    {handleSurgeryDate()}
                                </OrderSurgeryFont>
                            </SurgeryDateContainer>
                        )}
                    </TitleDateContainer>
                </TitleSubContainer>
                <CloseIconContainer>
                    {/* <CloseIcon
                        mobilePath={Close}
                        // onClick={() => setViewTemplate(false)}
                        show={true}
                        onClick={orderListDetailsClose}
                    /> */}
                </CloseIconContainer>
            </OrderDetailTitleContainer>
            <SurgeryCenterContainer
                isConsignment={orderBasicDetails?.currentOrderType === 'ZKA'}
                padding={isCondensedView && '0 1rem 0 1rem'}
            >
                <OrderSurgeryFont isCenter isDemi marginRight={false}>
                    {handleAccountName()}
                </OrderSurgeryFont>
                {/* {currentOrderType === 'KE' || currentOrderType === 'ZOR' ? (
                    <OrderSurgeryFont isCenter isDemi>
                        {handleAccountName()}
                    </OrderSurgeryFont>
                ) 
                : (
                    <OrderSurgeryFont isCenter isRegular>
                        {handleAccountName()}
                    </OrderSurgeryFont>
                )} */}

                <OrderSurgeryFont
                    marginRight={false}
                    isMargin={'0 0 0 5px'}
                    isItalic
                    isCenter
                    mobileMargin={'4px'}
                >
                    {handleAccountNumber()}
                </OrderSurgeryFont>
            </SurgeryCenterContainer>
        </>
    );
};

export default OrderDetailHeader;
